import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Informationen")
const _hoisted_2 = { class: "ion-padding-bottom" }
const _hoisted_3 = {
  key: 0,
  class: "ion-padding-bottom"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("b", null, " Produkt-Charakterisierung:", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Bewertung")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Aussehen")
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "(Rinde, Schnittfläche)", -1)
const _hoisted_9 = {
  ref: 'rating'+1,
  class: "vote-container"
}
const _hoisted_10 = {
  key: 0,
  class: "color-grey vote"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Teig/Konsistenz")
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "(Mundgefühl von Teig/Rinde)", -1)
const _hoisted_13 = {
  ref: 'rating'+2,
  class: "vote-container"
}
const _hoisted_14 = {
  key: 0,
  class: "color-grey vote"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Geruch")
const _hoisted_16 = {
  ref: 'rating'+3,
  class: "vote-container"
}
const _hoisted_17 = {
  key: 0,
  class: "color-grey vote"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Geschmack")
const _hoisted_19 = {
  ref: 'rating'+4,
  class: "vote-container"
}
const _hoisted_20 = {
  key: 0,
  class: "color-grey vote"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Kommentar ")
const _hoisted_22 = /*#__PURE__*/_createVNode("p", null, "Bitte begründen Sie Ihre Bewertung", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "card-pre-header danger" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("h6", null, "Fehlende Angaben", -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Bewertung bei ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" ist leer.")
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, "Bitte füllen Sie die fehlenden Punkte aus.", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Abschließen")
const _hoisted_31 = /*#__PURE__*/_createVNode("p", null, "Sie haben nochmal die Möglichkeit Ihre Bewertung zu überprüfen.", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Speichern ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_ion_loading = _resolveComponent("ion-loading")
  const _component_ion_card_title = _resolveComponent("ion-card-title")
  const _component_ion_card_header = _resolveComponent("ion-card-header")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_textarea = _resolveComponent("ion-textarea")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_IonCol = _resolveComponent("IonCol")
  const _component_IonRow = _resolveComponent("IonRow")
  const _component_IonGrid = _resolveComponent("IonGrid")
  const _component_IonContent = _resolveComponent("IonContent")
  const _component_IonPage = _resolveComponent("IonPage")

  return (_openBlock(), _createBlock(_component_IonPage, { class: "voting" }, {
    default: _withCtx(() => [
      _createVNode(_component_Header, {
        title: _ctx.getCheeseInfos?.coding,
        back: true
      }, null, 8, ["title"]),
      _createVNode(_component_IonContent, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_loading, {
            "is-open": _ctx.isCurrentlyLoading,
            message: "Speichern...",
            backdropDismiss: false
          }, null, 8, ["is-open"]),
          _createVNode(_component_IonGrid, null, {
            default: _withCtx(() => [
              _createVNode(_component_IonRow, { class: "ion-justify-content-center ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_IonCol, { class: "ion-text-center" }, {
                    default: _withCtx(() => [
                      (_ctx.getCheeseInfos?.juryDescription)
                        ? (_openBlock(), _createBlock(_component_ion_card, {
                            key: 0,
                            class: "ion-padding",
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, { class: "small" }, {
                                    default: _withCtx(() => [
                                      _hoisted_1
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createVNode("p", _hoisted_2, _toDisplayString(_ctx.getCheeseInfos?.productInfoString()), 1),
                                  (_ctx.getCheeseInfos?.juryDescription)
                                    ? (_openBlock(), _createBlock("p", _hoisted_3, [
                                        _hoisted_4,
                                        _hoisted_5,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCheeseInfos?.juryDescription), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_card, {
                        class: "ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small" }, {
                                default: _withCtx(() => [
                                  _hoisted_6
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, {
                        class: "ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small" }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              }),
                              _hoisted_8
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_9, [
                                (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (i) => {
                                  return _createVNode("div", {
                                    key: i,
                                    class: "votes",
                                    onClick: ($event: any) => (_ctx.setVote(1, i))
                                  }, [
                                    (i===1)
                                      ? (_openBlock(), _createBlock("div", _hoisted_10, "-"))
                                      : (_openBlock(), _createBlock("div", {
                                          key: 1,
                                          class: ['color-'+(i-1), "vote"]
                                        }, _toDisplayString((i + 3)), 3))
                                  ], 8, ["onClick"])
                                }), 64))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, {
                        class: "ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small" }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }),
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_13, [
                                (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (i) => {
                                  return _createVNode("div", {
                                    key: i,
                                    class: "votes",
                                    onClick: ($event: any) => (_ctx.setVote(2, i))
                                  }, [
                                    (i===1)
                                      ? (_openBlock(), _createBlock("div", _hoisted_14, "-"))
                                      : (_openBlock(), _createBlock("div", {
                                          key: 1,
                                          class: ['color-'+(i-1), "vote"]
                                        }, _toDisplayString((i + 3)), 3))
                                  ], 8, ["onClick"])
                                }), 64))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, {
                        class: "ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small" }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_16, [
                                (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (i) => {
                                  return _createVNode("div", {
                                    key: i,
                                    class: "votes",
                                    onClick: ($event: any) => (_ctx.setVote(3, i))
                                  }, [
                                    (i===1)
                                      ? (_openBlock(), _createBlock("div", _hoisted_17, "-"))
                                      : (_openBlock(), _createBlock("div", {
                                          key: 1,
                                          class: ['color-'+(i-1), "vote"]
                                        }, _toDisplayString((i + 3)), 3))
                                  ], 8, ["onClick"])
                                }), 64))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, {
                        class: "ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small" }, {
                                default: _withCtx(() => [
                                  _hoisted_18
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_19, [
                                (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (i) => {
                                  return _createVNode("div", {
                                    key: i,
                                    class: "votes",
                                    onClick: ($event: any) => (_ctx.setVote(4, i))
                                  }, [
                                    (i===1)
                                      ? (_openBlock(), _createBlock("div", _hoisted_20, "-"))
                                      : (_openBlock(), _createBlock("div", {
                                          key: 1,
                                          class: ['color-'+(i-1), "vote"]
                                        }, _toDisplayString((i + 3)), 3))
                                  ], 8, ["onClick"])
                                }), 64))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, {
                        class: "ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small" }, {
                                default: _withCtx(() => [
                                  _hoisted_21,
                                  _createVNode("span", { style: { color: 'var(--ion-color-danger)' } }, "*", 4)
                                ]),
                                _: 1
                              }),
                              _hoisted_22
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_textarea, {
                                ref: "comment",
                                modelValue: _ctx.comment,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.comment = $event)),
                                placeholder: "Text eingeben...",
                                required: true,
                                onChange: _ctx.setComment
                              }, null, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.error.show)
                        ? (_openBlock(), _createBlock(_component_ion_card, {
                            key: 1,
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23,
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _hoisted_24
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_content, { class: "danger-text" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.error, (err, index) => {
                                    return (_openBlock(), _createBlock("ul", { key: index }, [
                                      (err.value)
                                        ? (_openBlock(), _createBlock("li", _hoisted_25, [
                                            _hoisted_26,
                                            _createVNode("strong", null, _toDisplayString(err.lable), 1),
                                            _hoisted_27
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128)),
                                  _hoisted_28,
                                  _hoisted_29
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_card, {
                        class: "ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_30
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _hoisted_31,
                              _createVNode(_component_ion_button, {
                                class: "ion-margin",
                                expand: "block",
                                disabled: _ctx.comment?.length === 0,
                                onClick: _ctx.showVerifyModal
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_32
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}